import { useState, useEffect, useRef } from "react";
import * as Actions from "../../../../store/actions/schedulingportal/technicianAppointment";
import { PhoneNumberUtil } from "google-libphonenumber";
import { connect, useDispatch, useSelector } from "react-redux";
import "./ContactDetailsForm.css";
import { ContactNameRegex, EmailRegex } from "../../../../util/regexUtils";
import ContactDetailsForm from "./ContactDetailsForm";
import PropTypes from "prop-types";

const ContactDetailsFormValidation = (props) => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  const dispatch = useDispatch();
  const {
    windowSize,
    firstName: revealFirstName,
    surname: revealLastName,
    emailAddress: revealEmail,
    phoneNumber: revealPhoneNumber,
  } = useSelector((state) => state.ACCOUNT);
  const { isExistingContactNameEdited } = useSelector((state) => state.TECHNICIANAPPOINTMENT);

  const [firstName, setFirstName] = useState({
    showError: false,
    errorText: "",
    value: "",
    isEdited: false,
  });

  const [lastName, setLastName] = useState({
    showError: false,
    errorText: "",
    value: "",
    isEdited: false,
  });

  const [email, setEmail] = useState({
    showError: false,
    errorText: "",
    value: "",
    isEdited: false,
  });

  const [mobileNumber, setMobileNumber] = useState({
    showError: false,
    isDefault: true,
    errorText: "",
    isDisabled: false,
    value: "",
    isEdited: false,
  });

  const [landlineNumber, setLandlineNumber] = useState({
    showError: false,
    isDefault: true,
    errorText: "",
    isDisabled: false,
    value: props?.landlineNumber || "",
    isEdited: false,
  });

  const contactFormErrorRef = useRef(null);

  let contactID = "";

  useEffect(() => {
    if (
      props.userSelectedContactOption === "use-existing-contact" &&
      firstName?.value?.trim().toLowerCase() === "default" &&
      lastName?.value?.trim().toLowerCase() === "admin"
    ) {
      if (firstName?.value?.length) {
        dispatch(Actions.setIsExistingContactNameEdited(true));
        handleNameAndEmailValidation("firstName", firstName.value.trimStart());
      }
      if (lastName?.value?.length) {
        dispatch(Actions.setIsExistingContactNameEdited(true));
        handleNameAndEmailValidation("lastName", lastName.value.trimStart());
      }
    }
  }, [firstName.value, lastName.value]);

  useEffect(() => {
    // set focus to Contact Form fields if Appointment location section is focused and Contact Form fields are empty or have errors
    if (props.isContactFormError) {
      handleNameAndEmailValidation("firstName", firstName.value);
      handleNameAndEmailValidation("lastName", lastName.value);
      handleNameAndEmailValidation("email", email.value);
      handlePhoneNumberChange("mobile", mobileNumber.value);
      dispatch(Actions.setIsContactFormError(false));
    }
  }, [props.isContactFormError]);

 const isFormEdited = (firstName, lastName, email, mobileNumber) => {
  return firstName.isEdited || lastName.isEdited || email.isEdited || mobileNumber.isEdited;
};

const isFormValid = (firstName, lastName, email, mobileNumber) => {
  return (
    firstName.value &&
    !firstName.showError &&
    lastName.value &&
    !lastName.showError &&
    email.value &&
    !email.showError &&
    mobileNumber.value &&
    !mobileNumber.showError
  );
};

const getContactKeyAndType = (userSelectedContactOption, formId) => {
  if (userSelectedContactOption === "use-existing-contact") {
    return {
      contactKey: "existingContact",
      contactType: "use-existing-contact"
    };
  }
  
  if (userSelectedContactOption === "add-new-contact") {
    if (formId === "cfst-existing-contact-option") {
      return {
        contactKey: "existingContact",
        contactType: "use-existing-contact"
      };
    }
    return {
      contactKey: "newContact",
      contactType: "add-new-contact"
    };
  }
  
  // Fallback
  return {
    contactKey: userSelectedContactOption === "use-existing-contact" ? "existingContact" : "newContact",
    contactType: userSelectedContactOption
  };
};




useEffect(() => {
  const formEdited = isFormEdited(firstName, lastName, email, mobileNumber);
  
  if (formEdited) {
    handleEditedContactValues();
  }

  const formValid = isFormValid(firstName, lastName, email, mobileNumber);
  
  if (formValid && formEdited) {
    const { contactKey, contactType } = getContactKeyAndType(props.userSelectedContactOption, props.id);
    
    let formData = {
      firstName: firstName.value,
      lastName: lastName.value,
      email: email.value,
      mobileNumber: mobileNumber.value,
      landlineNumber: landlineNumber.value,
      contactID: contactID,
      contactType: contactType,
    };

    const data = {
      ...props.editedContactFormValues,
      [contactKey]: formData,
      selectedContactType: props.userSelectedContactOption,
    };

    console.log("Setting edited contact form values:", {
      formId: props.id,
      contactKey,
      userSelection: props.userSelectedContactOption,
      forceValidation: props.forceValidation,
      data,
    });

    dispatch(Actions.setEditedContactFormValues(data));
    props.setContactFormSuccess(true);
    props.setContactFormError(false);
  } else {
    props.setContactFormSuccess(false);
    props.setContactFormError(true);
  }
}, [firstName, lastName, email, mobileNumber, landlineNumber]);
  const getFieldValue = (formValue, fallbackValue) => formValue || fallbackValue;

const setFieldWithValue = (setter, value) => {
  if (value) {
    setter((prevState) => ({ ...prevState, value }));
  }
};

const populateExistingContactFields = (existingContact, revealData) => {
  const { revealFirstName, revealLastName, revealEmail, revealPhoneNumber } = revealData;
  
  setFieldWithValue(setFirstName, getFieldValue(existingContact?.firstName, revealFirstName));
  setFieldWithValue(setLastName, getFieldValue(existingContact?.lastName, revealLastName));
  setFieldWithValue(setEmail, getFieldValue(existingContact?.email, revealEmail));
  setFieldWithValue(setMobileNumber, getFieldValue(existingContact?.mobileNumber, revealPhoneNumber));
};

const validateExistingContactFields = (existingContact, revealData) => {
  const { revealFirstName, revealLastName, revealEmail, revealPhoneNumber } = revealData;
  
  const firstNameValue = getFieldValue(existingContact?.firstName, revealFirstName) || "";
  const lastNameValue = getFieldValue(existingContact?.lastName, revealLastName) || "";
  const emailValue = getFieldValue(existingContact?.email, revealEmail) || "";
  const phoneValue = getFieldValue(existingContact?.mobileNumber, revealPhoneNumber) || "";

  handleNameAndEmailValidation("firstName", firstNameValue);
  handleNameAndEmailValidation("lastName", lastNameValue);
  handleNameAndEmailValidation("email", emailValue);
  handlePhoneNumberChange("mobile", phoneValue);
};

const handleEmptyExistingContact = (revealData) => {
  const { revealEmail, revealPhoneNumber } = revealData;
  
  if (revealEmail) {
    handleNameAndEmailValidation("email", revealEmail);
  }
  if (revealPhoneNumber) {
    handlePhoneNumberChange("mobile", revealPhoneNumber, true);
  }
  checkForEmptyFields();
};

const handlePopulatedExistingContact = (existingContact, revealData) => {
  const { revealFirstName, revealLastName, revealEmail, revealPhoneNumber } = revealData;
  
  handleNameAndEmailValidation("firstName", getFieldValue(existingContact?.firstName, revealFirstName));
  handleNameAndEmailValidation("lastName", getFieldValue(existingContact?.lastName, revealLastName));
  handleNameAndEmailValidation("email", getFieldValue(existingContact?.email, revealEmail));
  handlePhoneNumberChange("mobile", getFieldValue(existingContact?.mobileNumber, revealPhoneNumber), true);
};

const populateNewContactFields = (newContact) => {
  setFirstName((prevState) => ({ ...prevState, value: newContact?.firstName || "" }));
  setLastName((prevState) => ({ ...prevState, value: newContact?.lastName || "" }));
  setEmail((prevState) => ({ ...prevState, value: newContact?.email || "" }));
  setMobileNumber((prevState) => ({ ...prevState, value: newContact?.mobileNumber || "" }));
};

const validateNewContactFields = (newContact) => {
  handleNameAndEmailValidation("firstName", newContact?.firstName);
  handleNameAndEmailValidation("lastName", newContact?.lastName);
  handleNameAndEmailValidation("email", newContact?.email);
  handlePhoneNumberChange("mobile", newContact?.mobileNumber, true);
};

const handleUseExistingContact = (props, revealData) => {
  const { existingContact } = props.contactFormValues;
  
  // Populate fields if not in force validation mode
  if (!props.forceValidation) {
    populateExistingContactFields(existingContact, revealData);
  }

  // Always validate immediately
  setTimeout(() => {
    validateExistingContactFields(existingContact, revealData);
  }, 0);

  // Handle empty vs populated existing contact
  if (Object.keys(existingContact).length === 0) {
    handleEmptyExistingContact(revealData);
  } else {
    handlePopulatedExistingContact(existingContact, revealData);
  }
};

const handleAddNewContact = (props, formState) => {
  const shouldSkipReset = props.forceValidation && props.id === "cfst-existing-contact-option";
  
  if (shouldSkipReset) {
    return;
  }

  const { newContact } = props.contactFormValues;
  const hasNewContactData = Object.keys(newContact).length !== 0;
  
  if (hasNewContactData) {
    populateNewContactFields(newContact);
    validateNewContactFields(newContact);
  } else {
    handleEmptyNewContactForm(props, formState);
  }
};

const handleEmptyNewContactForm = (props, formState) => {
  const { firstName, lastName, email, mobileNumber } = formState;
  const isNewContactForm = props.id === "cfst-new-contact-option";
  const allFieldsEmpty = !firstName.value && !lastName.value && !email.value && !mobileNumber.value;
  
  if (isNewContactForm && allFieldsEmpty) {
    console.log("New contact form - keeping existing values or starting fresh");
  }
};

useEffect(() => {
  const revealData = {
    revealFirstName,
    revealLastName, 
    revealEmail,
    revealPhoneNumber
  };
  
  const formState = {
    firstName,
    lastName,
    email,
    mobileNumber
  };

  if (props.userSelectedContactOption === "use-existing-contact") {
    handleUseExistingContact(props, revealData);
  } else if (props.userSelectedContactOption === "add-new-contact") {
    handleAddNewContact(props, formState);
  }
}, [props.userSelectedContactOption]);

  // New function to check for empty fields
  const checkForEmptyFields = () => {
    if (props.id === "cfst-existing-contact-option") {
      const isEmpty = !revealFirstName || !revealLastName || !revealEmail || !revealPhoneNumber;
      if (isEmpty) {
        props.setShowContactFormBanner?.(true);
      }
    }
  };

 const handleEditedContactValues = () => {
  const { contactKey, contactType } = getContactKeyAndType(props.userSelectedContactOption, props.id);

  let formData = {
    firstName: firstName.value,
    lastName: lastName.value,
    email: email.value,
    mobileNumber: mobileNumber.value,
    landlineNumber: landlineNumber.value,
    contactID: contactID,
    contactType: contactType,
  };

  const data = {
    ...props.contactFormValues,
    [contactKey]: formData,
    selectedContactType: props.userSelectedContactOption,
  };

  console.log("Updating contact values:", {
    formId: props.id,
    contactKey,
    userSelection: props.userSelectedContactOption,
    forceValidation: props.forceValidation,
    data,
  });

  dispatch(Actions.getContactValues(data));
};

  const resetContactForm = () => {
    setFirstName({
      showError: false,
      errorText: "",
      value: "",
      isEdited: false,
    });

    setLastName({
      showError: false,
      errorText: "",
      value: "",
      isEdited: false,
    });

    setEmail({
      showError: false,
      errorText: "",
      value: "",
      isEdited: false,
    });

    setMobileNumber({
      showError: false,
      isDefault: true,
      errorText: "",
      isDisabled: false,
      value: "",
      isEdited: false,
    });
  };

  const phoneNumberHandler = (value, onLoad = false, contactNumberType = "mobile") => {
    // contactNumberType will be "mobile" or "landline"
    let phoneValue = value,
      formattedPhoneNumber = "",
      showError = false,
      isDefault = true,
      errorText = "";

    if (value?.length && value.toLowerCase() !== "null") {
      // parseAndKeepRawInput() -- to get the phone number after parsing the special symbols without extension
      formattedPhoneNumber = phoneValue.indexOf("+") < 0 ? phoneValue : phoneUtil.parseAndKeepRawInput(phoneValue).values_[2];

      // First check if it's exactly 10 digits
      const digitsOnly = formattedPhoneNumber.replace(/\D/g, "");
      if (digitsOnly.length === 10) {
        // Then validate with Google phone library
        if (!isPhoneValid(digitsOnly)) {
          showError = true;
          errorText = `Phone number is invalid`;
          isDefault = false;
        }
      } else {
        showError = true;
        errorText = `Phone number must be 10 digits`;
        isDefault = false;
      }
    } else {
      showError = true;
      errorText = `Phone number is required`;
      isDefault = false;
    }
    return {
      value: onLoad ? formattedPhoneNumber : phoneValue,
      showError: showError,
      isDefault: isDefault,
      errorText: errorText,
    };
  };

  const mobileNumberHandler = (value, onLoad = false) => phoneNumberHandler(value, onLoad, "mobile");

  const isNonEmptyValid = (value) => value.length && value.toLowerCase() !== "null";
  const isInvalidSpecialName = (value, field, option) => {
  const specialNames = {
    firstName: "default",
    lastName: "admin",
  };
  return value.trim().toLowerCase() === specialNames[field] && 
         (option === "use-existing-contact" || props.forceValidation);
};

  const validateNameField = (field, value, setState) => {
  const isValid = ContactNameRegex.test(value);
  const option = props.userSelectedContactOption;

  if (!isNonEmptyValid(value)) {
    setState((prev) => ({
      ...prev,
      showError: true,
      errorText: `${field === "firstName" ? "First" : "Last"} name is required`,
      value,
      isEdited: true,
    }));
    return;
  }

  if (isValid) {
    if (isInvalidSpecialName(value, field, option)) {
      setState((prev) => ({
        ...prev,
        showError: true,
        errorText: `${field === "firstName" ? "First" : "Last"} name is invalid`,
        value,
        isEdited: true,
      }));
    } else {
      setState((prev) => ({
        ...prev,
        showError: false,
        errorText: "",
        value,
        isEdited: true,
      }));
    }
  } else {
    // Handle invalid regex for all cases
    setState((prev) => ({
      ...prev,
      showError: true,
      errorText: `${field === "firstName" ? "First" : "Last"} name is invalid`,
      value,
      isEdited: true,
    }));
  }
};

  const validateEmailField = (value) => {
  if (!isNonEmptyValid(value)) {
    setEmail((prev) => ({
      ...prev,
      showError: true,
      errorText: "Email address is required",
      value,
      isEdited: true,
    }));
    return;
  }

  if (EmailRegex.test(value)) {
    // Valid email format
    setEmail((prev) => ({
      ...prev,
      showError: false,
      errorText: "",
      value,
      isEdited: true,
    }));
  } else {
   
    const fallbackCheck = /^[a-zA-Z0-9+_.@-]+$/;
    
    if (fallbackCheck.test(value)) {
      // Valid characters but invalid format
      setEmail((prev) => ({
        ...prev,
        showError: true,
        errorText: "Email address is invalid",
        value,
        isEdited: true,
      }));
    } else {
      // Invalid characters
      setEmail((prev) => ({
        ...prev,
        showError: true,
        errorText: "Email address contains invalid characters",
        value,
        isEdited: true,
      }));
    }
  }
};
const validateLastNameField = (value) => {
  if (!isNonEmptyValid(value)) {
    setLastName((prev) => ({
      ...prev,
      showError: true,
      errorText: "Last name is required",
      value,
      isEdited: true,
    }));
    return;
  }

  // Check for special "admin" case first
  if (
    value.trim().toLowerCase() === "admin" &&
    props.id === "cfst-existing-contact-option" &&
    (props.userSelectedContactOption === "use-existing-contact" || props.forceValidation)
  ) {
    setLastName((prev) => ({
      ...prev,
      showError: true,
      errorText: "Last name is invalid",
      value,
      isEdited: true,
    }));
    return;
  }

  // Check primary regex validation
  if (ContactNameRegex.test(value)) {
    setLastName((prev) => ({
      ...prev,
      showError: false,
      errorText: "",
      value,
      isEdited: true,
    }));
    return;
  }

  // Check extended regex for names with special characters
  const extendedNameRegex = /^[a-zA-Z\s\-'.]+$/;
  if (extendedNameRegex.test(value) && value.trim().length >= 2) {
    setLastName((prev) => ({
      ...prev,
      showError: false,
      errorText: "",
      value,
      isEdited: true,
    }));
  } else {
    setLastName((prev) => ({
      ...prev,
      showError: true,
      errorText: "Last name is invalid",
      value,
      isEdited: true,
    }));
  }
};
 const handleNameAndEmailValidation = (field, value) => {
  switch (field) {
    case "firstName":
      validateNameField(field, value, setFirstName);
      break;
      
    case "lastName":
      validateLastNameField(value);
      break;
      
    case "email":
      validateEmailField(value);
      break;
      
    default:
      console.warn(`Unknown field: ${field}`);
  }
};

  const toFormatPhoneNumber = (inputValue) => {
    // Handled for USA only - Formatting the phone number to the format XXX XXX XXXX
    const input = inputValue.replace(/\D/g, "").substring(0, 15);
    const areaCode = input.length === 8 ? input.substring(0, 1) : input.substring(0, 3);
    const middle = input.length === 8 ? input.substring(1, 4) : input.substring(3, 6);
    const last = input.length === 8 ? input.substring(4, 15) : input.substring(6, 15);
    return `${areaCode} ${middle} ${last}`;
  };

  const isPhoneValid = (phone) => {
    // Handled for USA only - Validates the given extension and phone number with google library
    try {
      const phoneWithCountryCode = phone.startsWith("+1") ? phone : `+1${phone.replace(/\D/g, "")}`;
      return phoneUtil.isValidNumber(phoneUtil.parseAndKeepRawInput(phoneWithCountryCode));
    } catch (error) {
      console.error("Phone validation error:", error);
      return false;
    }
  };

  const handlePhoneNumberChange = (contactNumberType, value, onLoad = false) => {
    // on change of mobile and landline number fields
    if (contactNumberType === "mobile") {
      if (/^[0-9\s]*$/.test(value)) {
        let mobileNumberValidatedData = mobileNumberHandler(value, onLoad);
        setMobileNumber((prevState) => ({
          ...prevState,
          value: mobileNumberValidatedData.value,
          showError: mobileNumberValidatedData.showError,
          isDefault: mobileNumberValidatedData.isDefault,
          errorText: mobileNumberValidatedData.errorText,
          isEdited: true,
        }));
        //If we are setting the phone number on onload then format and display it.
        if (onLoad) {
          handlePhoneNumberOnBlur("mobile", mobileNumberValidatedData.value);
        }
      } else {
        setMobileNumber((prevState) => ({
          ...prevState,
          isEdited: true,
          showError: true,
          isDefault: false,
          errorText: `Phone number is invalid`,
        }));
      }
    }
  };

  const handlePhoneNumberOnBlur = (contactNumberType, phoneNumber) => {
    // on blur of mobile and landline number fields
    if (contactNumberType === "mobile") {
      phoneNumber.length > 0 &&
        setMobileNumber((prevState) => {
          return {
            ...prevState,
            value: toFormatPhoneNumber(phoneNumber),
          };
        });
    } else {
      phoneNumber.length > 0 &&
        setLandlineNumber((prevState) => {
          return {
            ...prevState,
            value: toFormatPhoneNumber(phoneNumber),
          };
        });
    }
  };

  useEffect(() => {
    // Force validation if forceValidation prop is true (for existing contact when switching to add new)
    if (props.forceValidation && props.id === "cfst-existing-contact-option") {

      // Force set banner immediately
      props.setShowContactFormBanner?.(true);

      // Pre-populate with existing contact data from Redux state
      setFirstName((prevState) => ({ ...prevState, value: revealFirstName || "", isEdited: true }));
      setLastName((prevState) => ({ ...prevState, value: revealLastName || "", isEdited: true }));
      setEmail((prevState) => ({ ...prevState, value: revealEmail || "", isEdited: true }));
      setMobileNumber((prevState) => ({ ...prevState, value: revealPhoneNumber || "", isEdited: true }));

      // Then validate the populated values
      setTimeout(() => {
        handleNameAndEmailValidation("firstName", revealFirstName || "");
        handleNameAndEmailValidation("lastName", revealLastName || "");
        handleNameAndEmailValidation("email", revealEmail || "");
        handlePhoneNumberChange("mobile", revealPhoneNumber || "");

        // Force banner again after validation
        props.setShowContactFormBanner?.(true);
        console.log("Force validation completed - banner should be visible");
      }, 0);
    }
  }, [props.forceValidation, props.id]);

  // Check for empty fields on component mount for existing contact
  useEffect(() => {
    if (props.id === "cfst-existing-contact-option") {
      // Check for missing fields
      const hasMissingFields = !revealFirstName || !revealLastName || !revealEmail || !revealPhoneNumber;

      // Check for validation errors in existing data
      const hasValidationErrors =
        (revealFirstName && revealFirstName.trim().toLowerCase() === "default") ||
        (revealLastName && revealLastName.trim().toLowerCase() === "admin") ||
        (revealEmail && !EmailRegex.test(revealEmail)) ||
        (revealPhoneNumber && !isPhoneValid(revealPhoneNumber.replace(/\D/g, ""))); // Use isPhoneValid instead of length check

      const hasErrors = hasMissingFields || hasValidationErrors;

      console.log("Checking empty fields AND validation errors for existing contact:", {
        revealFirstName,
        revealLastName,
        revealEmail,
        revealPhoneNumber,
        hasMissingFields,
        hasValidationErrors,
        hasErrors,
        forceValidation: props.forceValidation,
        phoneValidation: revealPhoneNumber ? isPhoneValid(revealPhoneNumber.replace(/\D/g, "")) : "No phone number",
      });

      if (hasErrors) {
        console.log("Setting banner to true for existing contact due to missing fields or validation errors");
        props.setShowContactFormBanner?.(true);
      }
    }
  }, [props.id, revealFirstName, revealLastName, revealEmail, revealPhoneNumber, props.forceValidation]);

  // Helper functions to reduce cognitive complexity
const checkFieldErrors = (firstName, lastName, email, mobileNumber) => {
  return firstName.showError || lastName.showError || email.showError || mobileNumber.showError;
};

const checkMissingFields = (firstName, lastName, email, mobileNumber) => {
  return !firstName.value || !lastName.value || !email.value || !mobileNumber.value;
};

const checkValidationErrors = (firstName, lastName, email, mobileNumber) => {
  return (
    (firstName?.value?.trim().toLowerCase() === "default") ||
    (lastName?.value?.trim().toLowerCase() === "admin") ||
    (email?.value && !EmailRegex.test(email.value)) ||
    (mobileNumber?.value && !isPhoneValid(mobileNumber.value.replace(/\D/g, "")))
  );
};

const isFormCompletelyValid = (firstName, lastName, email, mobileNumber, hasValidationErrors) => {
  return (
    firstName.value &&
    !firstName.showError &&
    lastName.value &&
    !lastName.showError &&
    email.value &&
    !email.showError &&
    mobileNumber.value &&
    !mobileNumber.showError &&
    !hasValidationErrors
  );
};

const logFormValidityCheck = ({
  hasFieldErrors,
  hasMissingFields,
  hasValidationErrors,
  totalErrors,
  firstName,
  lastName,
  email,
  mobileNumber
}) => {
  console.log("Form validity check:", {
    hasFieldErrors,
    hasMissingFields,
    hasValidationErrors,
    totalErrors,
    firstName: firstName.value,
    lastName: lastName.value,
    email: email.value,
    mobileNumber: mobileNumber.value,
    mobilePhoneValid: mobileNumber.value ? isPhoneValid(mobileNumber.value.replace(/\D/g, "")) : "No mobile number",
  });
};

const handleErrorState = (props, hasErrors) => {
  if (hasErrors) {
    props.setContactFormError?.(true);
    props.setShowContactFormBanner?.(true);
    console.log("Setting banner to true due to errors, missing fields, or validation errors");
  } else {
    props.setContactFormError?.(false);
    props.setShowContactFormBanner?.(false);
    console.log("Setting banner to false - all fields valid");
  }
};

const handleSuccessState = (props, isValid) => {
  if (isValid) {
    props.setContactFormSuccess(true);
    props.setContactFormError(false);
    props.setShowContactFormBanner?.(false);
  } else {
    props.setContactFormSuccess(false);
    props.setContactFormError(true);
  }
};

const handleExistingContactForm = (props, firstName, lastName, email, mobileNumber) => {
  const hasFieldErrors = checkFieldErrors(firstName, lastName, email, mobileNumber);
  const hasMissingFields = checkMissingFields(firstName, lastName, email, mobileNumber);
  const hasValidationErrors = checkValidationErrors(firstName, lastName, email, mobileNumber);
  const totalErrors = hasFieldErrors || hasMissingFields || hasValidationErrors;

  logFormValidityCheck({
    hasFieldErrors,
    hasMissingFields,
    hasValidationErrors,
    totalErrors,
    firstName,
    lastName,
    email,
    mobileNumber
  });
  
  handleErrorState(props, totalErrors);
  
  const isCompletelyValid = isFormCompletelyValid(firstName, lastName, email, mobileNumber, hasValidationErrors);
  handleSuccessState(props, isCompletelyValid);
};

const handleNewContactForm = (props, firstName, lastName, email, mobileNumber) => {
  // For new contact form, only validate the new contact fields themselves
  const isNewContactValid = isFormCompletelyValid(firstName, lastName, email, mobileNumber, false);
 if (props.userSelectedContactOption !== "add-new-contact") {
    handleSuccessState(props, isNewContactValid);
  }
};

// Refactored useEffect with reduced complexity
useEffect(() => {
  if (props.id === "cfst-existing-contact-option") {
    handleExistingContactForm(props, firstName, lastName, email, mobileNumber);
  } else if (props.id === "cfst-new-contact-option") {
    handleNewContactForm(props, firstName, lastName, email, mobileNumber);
  }
}, [firstName, lastName, email, mobileNumber, landlineNumber, props.forceValidation, props.id]);
  const checkMissingRevealFields = () => {
  return !revealFirstName || !revealLastName || !revealEmail || !revealPhoneNumber;
};

// Helper function to check for validation errors in reveal data
const checkRevealValidationErrors = () => {
  return (
    (revealFirstName && revealFirstName.trim().toLowerCase() === "default") ||
    (revealLastName && revealLastName.trim().toLowerCase() === "admin") ||
    (revealEmail && !EmailRegex.test(revealEmail)) ||
    (revealPhoneNumber && !isPhoneValid(revealPhoneNumber.replace(/\D/g, "")))
  );
};

// Helper function to set error state
const setContactFormErrorState = () => {
  props.setContactFormSuccess(false);
  props.setContactFormError?.(true);
  props.setShowContactFormBanner?.(true);
};

// Helper function to set success state
const setContactFormSuccessState = () => {
  props.setContactFormSuccess(true);
  props.setContactFormError?.(false);
  props.setShowContactFormBanner?.(false);
};

useEffect(() => {
  // Always validate existing contact data for next button logic, regardless of selected option
  const validateExistingContactForNextButton = () => {
    const hasMissingRevealFields = checkMissingRevealFields();
    const hasRevealValidationErrors = checkRevealValidationErrors();
    const hasExistingContactErrors = hasMissingRevealFields || hasRevealValidationErrors;

    // Handle add-new-contact option with existing contact errors
    if (props.userSelectedContactOption === "add-new-contact" && hasExistingContactErrors) {
      setContactFormErrorState();
      return;
    }

    // Handle use-existing-contact option
    if (props.userSelectedContactOption === "use-existing-contact") {
      if (hasExistingContactErrors) {
        console.log("DISABLING next button: Use existing contact selected and has errors");
        setContactFormErrorState();
      } else {
        console.log("ENABLING next button: Use existing contact selected and no errors");
        setContactFormSuccessState();
      }
    }
  };

  // Run validation immediately when contact option changes or reveal data changes
  validateExistingContactForNextButton();
}, [
  props.userSelectedContactOption,
  revealFirstName,
  revealLastName,
  revealEmail,
  revealPhoneNumber,
  props.setContactFormError,
  props.setShowContactFormBanner,
  props.setContactFormSuccess
]);
  // Helper functions to reduce cognitive complexity
const getInitialFieldValues = (existingContact, revealData) => {
  const { revealFirstName, revealLastName, revealEmail, revealPhoneNumber } = revealData;
  
  return {
    firstName: existingContact?.firstName || revealFirstName,
    lastName: existingContact?.lastName || revealLastName,
    email: existingContact?.email || revealEmail,
    phone: existingContact?.mobileNumber || revealPhoneNumber,
  };
};

const setFieldIfEmpty = (currentField, value, setter) => {
  if (!currentField.value && value) {
    setter((prevState) => ({ ...prevState, value }));
  }
};

const populateExistingContactInitialValues = (initialValues, currentFields, setters) => {
  const { firstName, lastName, email, phone } = initialValues;
  const { firstName: currentFirstName, lastName: currentLastName, email: currentEmail, mobileNumber: currentMobile } = currentFields;
  const { setFirstName, setLastName, setEmail, setMobileNumber } = setters;

  setFieldIfEmpty(currentFirstName, firstName, setFirstName);
  setFieldIfEmpty(currentLastName, lastName, setLastName);
  setFieldIfEmpty(currentEmail, email, setEmail);
  setFieldIfEmpty(currentMobile, phone, setMobileNumber);
};

const validateInitialValues = (initialValues, validationHandlers) => {
  const { firstName, lastName, email, phone } = initialValues;
  const { handleNameAndEmailValidation, handlePhoneNumberChange } = validationHandlers;

  // Validate fields with values
  if (firstName) handleNameAndEmailValidation("firstName", firstName);
  if (lastName) handleNameAndEmailValidation("lastName", lastName);
  if (email) handleNameAndEmailValidation("email", email);
  if (phone) handlePhoneNumberChange("mobile", phone);

  // Force validation for empty fields
  if (!firstName) handleNameAndEmailValidation("firstName", "");
  if (!lastName) handleNameAndEmailValidation("lastName", "");
  if (!email) handleNameAndEmailValidation("email", "");
  if (!phone) handlePhoneNumberChange("mobile", "");
};

const handleExistingContactInitialization = (props, revealData, currentFields, setters, validationHandlers) => {
  const initialValues = getInitialFieldValues(props.contactFormValues.existingContact, revealData);
  
  populateExistingContactInitialValues(initialValues, currentFields, setters);
  
  setTimeout(() => {
    validateInitialValues(initialValues, validationHandlers);
  }, 0);
};

const setNewContactFieldIfNotEdited = (newContactValue, currentField, setter) => {
  if (newContactValue && !currentField.isEdited) {
    setter((prevState) => ({ ...prevState, value: newContactValue }));
  }
};

const handleNewContactInitialization = (newContactData, currentFields, setters) => {
  if (!newContactData || Object.keys(newContactData).length === 0) {
    return;
  }

  const { firstName, lastName, email, mobileNumber } = currentFields;
  const { setFirstName, setLastName, setEmail, setMobileNumber } = setters;

  setNewContactFieldIfNotEdited(newContactData.firstName, firstName, setFirstName);
  setNewContactFieldIfNotEdited(newContactData.lastName, lastName, setLastName);
  setNewContactFieldIfNotEdited(newContactData.email, email, setEmail);
  setNewContactFieldIfNotEdited(newContactData.mobileNumber, mobileNumber, setMobileNumber);
};

const shouldInitializeExistingContact = (props) => {
  return props.id === "cfst-existing-contact-option" && 
         (props.userSelectedContactOption === "use-existing-contact" || props.forceValidation);
};

// Refactored useEffect with reduced complexity
useEffect(() => {
  const revealData = { revealFirstName, revealLastName, revealEmail, revealPhoneNumber };
  const currentFields = { firstName, lastName, email, mobileNumber };
  const setters = { setFirstName, setLastName, setEmail, setMobileNumber };
  const validationHandlers = { handleNameAndEmailValidation, handlePhoneNumberChange };

  if (shouldInitializeExistingContact(props)) {
    handleExistingContactInitialization(props, revealData, currentFields, setters, validationHandlers);
  } else if (props.id === "cfst-new-contact-option") {
    handleNewContactInitialization(props.contactFormValues.newContact, currentFields, setters);
  }
}, [props.id, props.userSelectedContactOption, props.forceValidation]);
  const clearContactFormData = () => {
    // Reset local state
    resetContactForm();
  };
  useEffect(() => {
    if (props.clearFormData) {
      clearContactFormData();
      props.onFormDataCleared?.();
    }
  }, [props.clearFormData]);
  return (
    <ContactDetailsForm
      windowSize={windowSize}
      contactFormErrorRef={contactFormErrorRef}
      firstName={firstName}
      lastName={lastName}
      email={email}
      mobileNumber={mobileNumber}
      handleNameAndEmailValidation={handleNameAndEmailValidation}
      handlePhoneNumberChange={handlePhoneNumberChange}
      handlePhoneNumberOnBlur={handlePhoneNumberOnBlur}
      userSelectedContactOption={props.userSelectedContactOption}
      isExistingContactNameEdited={isExistingContactNameEdited}
      showContactFormBanner={props.showContactFormBanner}
      bannerRef={props.bannerRef}
      formId={props.id} // Pass the form ID
    />
  );
};

const mapStateToProps = (state) => {
  return {
    userSelectedContactOption: state.TECHNICIANAPPOINTMENT.userSelectedContactOption,
    windowSize: state.ACCOUNT.windowSize,
    firstName: state.TECHNICIANAPPOINTMENT.firstName,
    lastName: state.TECHNICIANAPPOINTMENT.lastName,
    email: state.TECHNICIANAPPOINTMENT.email,
    mobileNumber: state.TECHNICIANAPPOINTMENT.mobileNumber,
    landlineNumber: state.TECHNICIANAPPOINTMENT.landlineNumber,
    contactFormValues: state.TECHNICIANAPPOINTMENT.contactFormValues,
    isContactFormError: state.TECHNICIANAPPOINTMENT.isContactFormError,
    editedContactFormValues: state.TECHNICIANAPPOINTMENT.editedContactFormValues,
  };
};

const mapDispatchToProps = {};

ContactDetailsFormValidation.propTypes = {
  id: PropTypes.string,
  userSelectedContactOption: PropTypes.string,
  forceValidation: PropTypes.bool,
  isContactFormError: PropTypes.bool,
  landlineNumber: PropTypes.string,
  editedContactFormValues: PropTypes.object,
  contactFormValues: PropTypes.object,
  setContactFormSuccess: PropTypes.func,
  setContactFormError: PropTypes.func,
  setShowContactFormBanner: PropTypes.func,
  showContactFormBanner: PropTypes.bool,
  clearFormData: PropTypes.bool,
  bannerRef: PropTypes.any,
  onFormDataCleared: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactDetailsFormValidation);
